(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────────────────────────
  // 1. GATE — clip-path scroll animation (desktop ≥768px)
  // ─────────────────────────────────────────────────────────────────────────────
  function initGateClipPath() {
    const wrapper = document.querySelector('.gate-wrapper');
    const clipper = document.querySelector('.gate-clip-layer');
    const img     = document.querySelector('.gate-img-layer');
    if (!wrapper || !clipper || !img) return;
    if (window.innerWidth <= 767) return;

    const easeIn = function (t) { return t * t; };
    let raf = null;

    function update() {
      const rect  = wrapper.getBoundingClientRect();
      const range = rect.height - window.innerHeight;
      if (range <= 0) return;
      const p = Math.max(0, Math.min(1, -rect.top / range));
      const v = easeIn(p);
      clipper.style.clipPath = 'inset(' + (37 * v) + '% ' + (37 * v) + '% ' + (41 * v) + '% ' + (37 * v) + '%)';
      img.style.transform    = 'translate(' + (-10 * v) + '%, ' + (-1.5 * v) + '%) scale(' + (1 + 0.4 * v) + ')';
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = null; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 1b. GATE — scroll-hint fade-out
  // ─────────────────────────────────────────────────────────────────────────────
  function initGateScrollHint() {
    const wrapper    = document.querySelector('.gate-wrapper');
    const scrollHint = document.querySelector('.gate-scroll-hint');
    if (!wrapper || !scrollHint) return;

    let raf = null;

    function update() {
      const rect     = wrapper.getBoundingClientRect();
      const range    = rect.height - window.innerHeight;
      if (range <= 0) return;
      const progress = Math.max(0, Math.min(1, -rect.top / range));
      scrollHint.style.opacity = String(Math.max(0, 1 - progress / 0.05));
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = null; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. GATE — word entrance animation
  // ─────────────────────────────────────────────────────────────────────────────
  function initGateWords() {
    var words = document.querySelectorAll('.gate-word');
    if (!words.length) return;
    words.forEach(function (word, i) {
      setTimeout(function () {
        word.classList.add('animate');
      }, 480 + i * 70);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. GATE — CTA button → scroll to #packs-stars
  // ─────────────────────────────────────────────────────────────────────────────
  function initGateCTA() {
    var btn   = document.querySelector('.gate-btn-cta');
    var packs = document.querySelector('#packs-stars');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (packs) {
        packs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. GATE — FOMO widget fade-in after 1250ms
  // ─────────────────────────────────────────────────────────────────────────────
  function initGateFomo() {
    var fomo = document.querySelector('.gate-fomo');
    if (!fomo) return;
    fomo.style.opacity   = '0';
    fomo.style.transform = 'translateY(8px)';
    fomo.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    setTimeout(function () {
      fomo.style.opacity   = '1';
      fomo.style.transform = 'translateY(0)';
    }, 1250);
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. PACKS STARS — image slider (prev/next, dots, swipe, cross-fade)
  // ─────────────────────────────────────────────────────────────────────────────
  function initPackSliders() {
    document.querySelectorAll('.pack-card').forEach(function (card) {
      var slider = card.querySelector('.pack-slider');
      if (!slider) return;

      var imgs    = Array.from(slider.querySelectorAll('.pack-slider__img'));
      var dots    = Array.from(slider.querySelectorAll('.pack-slider__dot'));
      var btnPrev = slider.querySelector('.pack-slider__btn--prev');
      var btnNext = slider.querySelector('.pack-slider__btn--next');
      var current     = 0;
      var touchStartX = 0;

      function go(idx) {
        imgs[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (idx + imgs.length) % imgs.length;
        imgs[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      go(0);

      if (btnPrev) {
        btnPrev.addEventListener('click', function (e) {
          e.stopPropagation();
          go(current - 1);
        });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function (e) {
          e.stopPropagation();
          go(current + 1);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          go(i);
        });
      });

      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          go(diff > 0 ? current + 1 : current - 1);
        }
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 5b. PACKS — open cart drawer after AJAX add
  // ─────────────────────────────────────────────────────────────────────────────
  function openCartDrawer() {
    function doOpen() {
      var trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) { trigger.click(); return; }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        var html = sections && sections['cart-drawer'];
        if (html) {
          var tmp   = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#cart-drawer');
          var live  = document.querySelector('#cart-drawer');
          if (fresh && live) { live.innerHTML = fresh.innerHTML; }
        }
        doOpen();
      })
      .catch(function () { doOpen(); });
  }

  function initPacksCTA() {
    document.querySelectorAll('.pack-cta-btn[data-url]').forEach(function (el) {
      el.addEventListener('click', function () {
        var variantId = el.dataset.variantId;
        var url       = el.dataset.url;
        if (!variantId) {
          if (url) window.location.href = url;
          return;
        }
        el.disabled = true;
        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () { openCartDrawer(); })
          .catch(function () { if (url) window.location.href = url; })
          .finally(function () { el.disabled = false; });
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. PACKS STARS — composition accordion (mobile)
  // ─────────────────────────────────────────────────────────────────────────────
  function initPackComposition() {
    document.querySelectorAll('.pack-compo-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list   = btn.nextElementSibling;
        if (!list) return;
        var isOpen = list.classList.contains('is-open');
        btn.classList.toggle('is-open', !isOpen);
        list.classList.toggle('is-open', !isOpen);
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. PACKS STARS — stock count-up animation
  // ─────────────────────────────────────────────────────────────────────────────
  function initStockCountUp() {
    document.querySelectorAll('.pack-stock-badge__count[data-target]').forEach(function (el) {
      var target = parseInt(el.dataset.target, 10);
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) return;
        io.disconnect();
        var steps    = 28;
        var duration = 900;
        var stepTime = duration / steps;
        var cur = 0;
        function tick() {
          cur++;
          var progress = cur / steps;
          el.textContent = String(Math.round(target * (1 - Math.pow(1 - progress, 3))));
          if (cur < steps) setTimeout(tick, stepTime);
        }
        setTimeout(tick, 120);
      }, { rootMargin: '-40px' });
      io.observe(el);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. PACKS STARS — stock gauge fill
  // ─────────────────────────────────────────────────────────────────────────────
  function initStockGauge() {
    document.querySelectorAll('.pack-gauge__fill[data-width]').forEach(function (el) {
      el.style.width = el.dataset.width + '%';
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. POURQUOI VP — count-up 00 → 01/02/03
  // ─────────────────────────────────────────────────────────────────────────────
  function initPourquoiCountUp() {
    document.querySelectorAll('.pourquoi-raison-num[data-target]').forEach(function (el) {
      var target = parseInt(el.dataset.target, 10);
      var idx    = parseInt(el.dataset.idx || '0', 10);
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) return;
        io.disconnect();
        el.textContent = '00';
        var cur = 0;
        function tick() {
          cur++;
          el.textContent = String(cur).padStart(2, '0');
          if (cur < target) setTimeout(tick, 80);
        }
        setTimeout(tick, idx * 120);
      }, { rootMargin: '-80px' });
      io.observe(el);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 10. POURQUOI VP — bar animate height 0 → 42px
  // ─────────────────────────────────────────────────────────────────────────────
  function initPourquoiBars() {
    document.querySelectorAll('.pourquoi-raison-bar').forEach(function (bar) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) return;
        io.disconnect();
        bar.classList.add('animate');
      }, { rootMargin: '-60px' });
      io.observe(bar);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 11. CATALOGUE — filter tabs
  // ─────────────────────────────────────────────────────────────────────────────
  function initCatalogueTabs() {
    var tabs     = document.querySelectorAll('.catalogue-tab');
    var products = document.querySelectorAll('.catalogue-product');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var filter = tab.dataset.filter;
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        products.forEach(function (p) {
          if (filter === 'all' || p.dataset.type === filter) {
            p.style.display = '';
          } else {
            p.style.display = 'none';
          }
        });
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 12. AVIS — infinite carousel
  // ─────────────────────────────────────────────────────────────────────────────
  function initAvisCarousel() {
    var track   = document.querySelector('.avis-track');
    var dots    = document.querySelectorAll('.avis-dot');
    var counter = document.querySelector('.avis-nav-counter');
    var btnPrev = document.querySelector('.avis-btn--prev');
    var btnNext = document.querySelector('.avis-btn--next');
    if (!track) return;

    var N = 6; // original items count
    var jumpTimer = null;

    function getStep() {
      var firstSlot = track.children[1]; // skip optional spacer at [0]
      if (!firstSlot) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return firstSlot.offsetWidth + gap;
    }

    function setActiveIndex(idx) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + N;
    }

    function init() {
      var step = getStep();
      if (step > 0) track.scrollLeft = N * step;
      setActiveIndex(0);
    }

    track.addEventListener('scroll', function () {
      var step = getStep();
      if (!step) return;
      var rawIdx = Math.round(track.scrollLeft / step);
      setActiveIndex(((rawIdx % N) + N) % N);

      if (jumpTimer) clearTimeout(jumpTimer);
      jumpTimer = setTimeout(function () {
        if (rawIdx < N) {
          track.scrollLeft += N * step;
        } else if (rawIdx >= N * 2) {
          track.scrollLeft -= N * step;
        }
      }, 60);
    }, { passive: true });

    function scrollByDir(dir) {
      var step = getStep();
      if (step) track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function scrollToIndex(i) {
      var step = getStep();
      if (step) track.scrollTo({ left: (N + i) * step, behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { scrollByDir(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { scrollByDir(1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { scrollToIndex(i); });
    });

    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', init);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 13. FAQ — accordion (first item open by default)
  // ─────────────────────────────────────────────────────────────────────────────
  function initFAQ() {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item, i) {
      var btn = item.querySelector('.faq-item__btn');
      if (!btn) return;
      if (i === 0) item.classList.add('is-open');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (it) { it.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 14. OFFRE CTA — parallax background
  // ─────────────────────────────────────────────────────────────────────────────
  function initOffreCTAParallax() {
    var section = document.querySelector('.offre-section');
    var bg      = section ? section.querySelector('.offre-bg-wrap') : null;
    if (!section || !bg) return;

    var raf = null;

    function update() {
      var rect     = section.getBoundingClientRect();
      var vh       = window.innerHeight;
      // progress: 0 when section top at bottom of viewport, 1 when section bottom at top
      var progress = (vh - rect.top) / (vh + rect.height);
      var p        = Math.max(0, Math.min(1, progress));
      var y        = -8 + p * 16; // -8% → +8%
      bg.style.transform = 'translateY(' + y + '%)';
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = null; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 15. MOBILE — ReassuranceBar auto-advance
  // ─────────────────────────────────────────────────────────────────────────────
  function initReassuranceBar() {
    var rb = document.querySelector('.endro-rb__list');
    if (!rb || window.innerWidth >= 700) return;

    var paused = false;

    var interval = setInterval(function () {
      if (paused) return;
      rb.scrollBy({ left: rb.clientWidth, behavior: 'smooth' });
      if (rb.scrollLeft + rb.clientWidth >= rb.scrollWidth - 10) {
        setTimeout(function () { rb.scrollLeft = 0; }, 500);
      }
    }, 3000);

    rb.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    rb.addEventListener('touchend', function () {
      setTimeout(function () { paused = false; }, 1500);
    }, { passive: true });

    // Suppress unused variable warning — interval kept for potential clearInterval use
    void interval;
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 16. MOBILE NAV BAR — appear after hero, CTA text changes, scroll to packs
  // ─────────────────────────────────────────────────────────────────────────────
  function initMobileNavBar() {
    var navbar = document.querySelector('.endro-navbar');
    var btn    = navbar ? navbar.querySelector('.endro-navbar__btn') : null;
    if (!navbar || !btn) return;

    var hero  = document.querySelector('.gate-wrapper');
    var packs = document.querySelector('#packs-stars');
    var raf   = null;

    function update() {
      var heroRect  = hero ? hero.getBoundingClientRect() : null;
      var packsRect = packs ? packs.getBoundingClientRect() : null;

      var heroGone       = heroRect ? heroRect.bottom < 0 : false;
      navbar.classList.toggle('is-visible', heroGone);

      var packsBelowFold = packsRect ? packsRect.bottom > window.innerHeight : true;
      btn.textContent    = packsBelowFold ? 'Voir les coffrets' : 'Voir le catalogue';
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = null; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', function () {
      if (packs) packs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    update();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 17. GENERIC SCROLL REVEAL — .evp-reveal → .is-visible
  // ─────────────────────────────────────────────────────────────────────────────
  function initScrollReveal() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-60px', threshold: 0 });

    document.querySelectorAll('.evp-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 18. PACKS SECTION — entrance animation (desktop)
  // ─────────────────────────────────────────────────────────────────────────────
  function initPacksEntrance() {
    var section = document.querySelector('.packs-section');
    if (!section || window.innerWidth <= 767) return;

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        section.classList.add('is-entered');
        io.disconnect();
      }
    }, { threshold: 0.01 });

    io.observe(section);
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // 19. PACKS — clic image → fiche produit (exclut dots, arrows, badge)
  // ─────────────────────────────────────────────────────────────────────────────
  function initPackImageLink() {
    document.querySelectorAll('.pack-card').forEach(function (card) {
      var imgWrap = card.querySelector('.pack-card__img-wrap');
      var ctaBtn  = card.querySelector('.pack-cta-btn');
      var url     = ctaBtn ? ctaBtn.dataset.url : null;
      if (!imgWrap || !url) return;
      imgWrap.style.cursor = 'pointer';
      imgWrap.addEventListener('click', function (e) {
        if (e.target.closest('.pack-slider__btn') ||
            e.target.closest('.pack-slider__dots') ||
            e.target.closest('.pack-discount-badge')) return;
        window.location.href = url;
      });
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // MAIN ENTRY POINT
  // ─────────────────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initGateClipPath();
    initGateScrollHint();
    initGateWords();
    initGateFomo();
    initGateCTA();
    initPackSliders();
    initPacksCTA();
    initPackComposition();
    initStockCountUp();
    initStockGauge();
    initPourquoiCountUp();
    initPourquoiBars();
    initCatalogueTabs();
    initAvisCarousel();
    initFAQ();
    initOffreCTAParallax();
    initReassuranceBar();
    initMobileNavBar();
    initScrollReveal();
    initPacksEntrance();
    initPackImageLink();
  });

})();
